export default "__VITE_ASSET__URxnqbS1__"